import { render, staticRenderFns } from "./forgot_password.html?vue&type=template&id=9338e9de&scoped=true&"
import script from "./forgot_password.js?vue&type=script&lang=js&"
export * from "./forgot_password.js?vue&type=script&lang=js&"
import style0 from "./forgot_password.scss?vue&type=style&index=0&id=9338e9de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9338e9de",
  null
  
)

export default component.exports